import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isoWeek from "dayjs/plugin/isoWeek";
import updateLocale from "dayjs/plugin/updateLocale";
dayjs.extend(updateLocale);
dayjs.extend(advancedFormat);
dayjs.extend(isoWeek);
dayjs.updateLocale("en", {
    weekStart: 1,
});
export var date = dayjs;
//# sourceMappingURL=date.helper.js.map